import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ManagePukalService } from '../../../../services/manage-pukal.service'
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material';
import { WMSValidators } from '../../../../shared/validators';

@Component({
    selector: 'dialog-other-addnewaccount',
    templateUrl: 'dialog.addnewaccount.html',
    styleUrls: ['dialog.addnewaccount.css']
})
export class AddNewAccountOtherGovernmentPukalDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    isSubmit: boolean = false;
    addnewaccform: FormGroup;
    errorMessage: string = '';
    agencyCodes = [];
    accoffices = [];
    activations = [];
    warrant_auth_code: string = 'OT';

    constructor(public dialogRef: MatDialogRef<AddNewAccountOtherGovernmentPukalDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private managePukalService: ManagePukalService,
        public snackBar: MatSnackBar) { }

    ngOnInit() {
        this.addnewaccform = new FormGroup({
            agencyCode: new FormControl({ value: '', disabled: false }),
            accOffice: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.min(1)]),
            pukalnumber: new FormControl({ value: '', disabled: true }),
            activation: new FormControl({ value: '', disabled: false }),
            invdepartment: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            invaddress: new FormControl({ value: '', disabled: false }, [Validators.maxLength(100)]),
            invofficername: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            invphoneno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            invfaxno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            invemail: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)]),
            invnamebankacc: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            invbankaccno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            departmentname: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(50)]),
            departmentaddress: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(100)]),
            departmentofficername: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            departmentphonenumber: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            departmentfaxnumber: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            departmentemail: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)]),
            chargedeparment: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            chargeaddress: new FormControl({ value: '', disabled: false }, [Validators.maxLength(100)]),
            chargeofficer: new FormControl({ value: '', disabled: false }, [Validators.maxLength(50)]),
            chargephoneno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            chargefaxno: new FormControl({ value: '', disabled: false }, [Validators.maxLength(20)]),
            chargeemail: new FormControl({ value: '', disabled: false }, [WMSValidators.email, Validators.maxLength(50)])
        });

        let init_sub = this.managePukalService.getOTHAddPukalAccountLoad(this.warrant_auth_code)
            .subscribe(
                (value) => {
                    this.agencyCodes = value.body['agentCodes'];
                    this.accoffices = value.body['accountOffices'];
                    this.activations = value.body['accountStatus'];

                    this.addnewaccform.setValue({
                        agencyCode: this.agencyCodes[0].Airline_Agency_Code,
                        accOffice: '',
                        pukalnumber: 'System Generate',
                        activation: this.activations[0].StatusCode,
                        invdepartment: '',
                        invaddress: '',
                        invofficername: '',
                        invphoneno: '',
                        invfaxno: '',
                        invemail: '',
                        invnamebankacc: '',
                        invbankaccno: '',
                        departmentname: '',
                        departmentaddress: '',
                        departmentofficername: '',
                        departmentphonenumber: '',
                        departmentfaxnumber: '',
                        departmentemail: '',
                        chargedeparment: '',
                        chargeaddress: '',
                        chargeofficer: '',
                        chargephoneno: '',
                        chargefaxno: '',
                        chargeemail: ''
                    });
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.openSnackBar(this.errorMessage, '');
                });

        //Adds into array for each subscribe
        this.allSub.push(init_sub);
    }

    onSubmit(form: FormGroup) {
        let cfm = confirm("Are you sure you want to add new Pukal Account?");

        if (cfm) {
            this.isSubmit = true;

            let newPukalAccount = {
                Airline_Agency_Code: this.addnewaccform.get('agencyCode')!.value,
                Acc_Off_Code: this.addnewaccform.get('accOffice')!.value,
                Acc_No: '',
                Acc_Sts_Code: this.addnewaccform.get('activation')!.value,
                Inv_Department_Name: this.addnewaccform.get('invdepartment')!.value,
                Inv_Address: this.addnewaccform.get("invaddress")!.value,
                Inv_Officer_Name: this.addnewaccform.get("invofficername")!.value,
                Inv_Phone_No: this.addnewaccform.get("invphoneno")!.value,
                Inv_Fax_No: this.addnewaccform.get("invfaxno")!.value,
                Inv_Email: this.addnewaccform.get("invemail")!.value,
                Name_Bank_Acc: this.addnewaccform.get("invnamebankacc")!.value,
                Bank_Acc_No: this.addnewaccform.get("invbankaccno")!.value,
                Department_Name: this.addnewaccform.get("departmentname")!.value,
                Address: this.addnewaccform.get("departmentaddress")!.value,
                Officer_Name: this.addnewaccform.get("departmentofficername")!.value,
                Phone_No: this.addnewaccform.get("departmentphonenumber")!.value,
                Fax_No: this.addnewaccform.get("departmentfaxnumber")!.value,
                Email: this.addnewaccform.get("departmentemail")!.value,
                Pyt_Department_Name: this.addnewaccform.get("chargedeparment")!.value,
                Pyt_Address: this.addnewaccform.get("chargeaddress")!.value,
                Pyt_Officer_Name: this.addnewaccform.get("chargeofficer")!.value,
                Pyt_Phone_No: this.addnewaccform.get("chargephoneno")!.value,
                Pyt_Fax_No: this.addnewaccform.get("chargefaxno")!.value,
                Pyt_Email: this.addnewaccform.get("chargeemail")!.value
            }

            let save_sub = this.managePukalService.OTHAddNewPukalAccount(newPukalAccount)
                .subscribe(
                    (value) => {
                        if (value.status === 200) {
                            this.dialogRef.close('Add new successful');
                        }
                    },
                    (error) => {
                        this.errorMessage = <any>error;
                        this.openSnackBar(this.errorMessage, '');
                    });

            //Adds into array for each subscribe
            this.allSub.push(save_sub);
        } else {
            this.isSubmit = false;
        }
    }

    IICopyFromDeptInfo() {
        this.addnewaccform.setValue({
            agencyCode: this.addnewaccform.get('agencyCode')!.value,
            accOffice: this.addnewaccform.get('accOffice')!.value,
            pukalnumber: this.addnewaccform.get('pukalnumber')!.value,
            activation: this.addnewaccform.get('activation')!.value,
            invdepartment: this.addnewaccform.get("departmentname")!.value,
            invaddress: this.addnewaccform.get("departmentaddress")!.value,
            invofficername: this.addnewaccform.get("departmentofficername")!.value,
            invphoneno: this.addnewaccform.get("departmentphonenumber")!.value,
            invfaxno: this.addnewaccform.get("departmentfaxnumber")!.value,
            invemail: this.addnewaccform.get("departmentemail")!.value,
            invnamebankacc: this.addnewaccform.get('invnamebankacc')!.value,
            invbankaccno: this.addnewaccform.get('invbankaccno')!.value,
            departmentname: this.addnewaccform.get("departmentname")!.value,
            departmentaddress: this.addnewaccform.get("departmentaddress")!.value,
            departmentofficername: this.addnewaccform.get("departmentofficername")!.value,
            departmentphonenumber: this.addnewaccform.get("departmentphonenumber")!.value,
            departmentfaxnumber: this.addnewaccform.get("departmentfaxnumber")!.value,
            departmentemail: this.addnewaccform.get("departmentemail")!.value,
            chargedeparment: this.addnewaccform.get("chargedeparment")!.value,
            chargeaddress: this.addnewaccform.get("chargeaddress")!.value,
            chargeofficer: this.addnewaccform.get("chargeofficer")!.value,
            chargephoneno: this.addnewaccform.get("chargephoneno")!.value,
            chargefaxno: this.addnewaccform.get("chargefaxno")!.value,
            chargeemail: this.addnewaccform.get("chargeemail")!.value
        });
    }

    PICopyFromDeptInfo() {
        this.addnewaccform.setValue({
            agencyCode: this.addnewaccform.get('agencyCode')!.value,
            accOffice: this.addnewaccform.get('accOffice')!.value,
            pukalnumber: this.addnewaccform.get('pukalnumber')!.value,
            activation: this.addnewaccform.get('activation')!.value,
            invdepartment: this.addnewaccform.get('invdepartment')!.value,
            invaddress: this.addnewaccform.get('invaddress')!.value,
            invofficername: this.addnewaccform.get('invofficername')!.value,
            invphoneno: this.addnewaccform.get('invphoneno')!.value,
            invfaxno: this.addnewaccform.get('invfaxno')!.value,
            invemail: this.addnewaccform.get('invemail')!.value,
            invnamebankacc: this.addnewaccform.get('invnamebankacc')!.value,
            invbankaccno: this.addnewaccform.get('invbankaccno')!.value,
            departmentname: this.addnewaccform.get("departmentname")!.value,
            departmentaddress: this.addnewaccform.get("departmentaddress")!.value,
            departmentofficername: this.addnewaccform.get("departmentofficername")!.value,
            departmentphonenumber: this.addnewaccform.get("departmentphonenumber")!.value,
            departmentfaxnumber: this.addnewaccform.get("departmentfaxnumber")!.value,
            departmentemail: this.addnewaccform.get("departmentemail")!.value,
            chargedeparment: this.addnewaccform.get("departmentname")!.value,
            chargeaddress: this.addnewaccform.get("departmentaddress")!.value,
            chargeofficer: this.addnewaccform.get("departmentofficername")!.value,
            chargephoneno: this.addnewaccform.get("departmentfaxnumber")!.value,
            chargefaxno: this.addnewaccform.get("departmentfaxnumber")!.value,
            chargeemail: this.addnewaccform.get("departmentemail")!.value
        });
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }

    openSnackBar(message: string, action: string) {
        this.snackBar.open(message, action, {
            duration: 3000,
        });
    }
}